<template>
    <div class="convention-body">
        <typo name="cc-body" v-html="body" />
    </div>
</template>

<script>
import Vue from "vue";

export default Vue.extend({
    components: {},
    props: ["synchronizedSection"],
    name: "AnnotationTypeSynchronize",
    methods: {
        getNextSiblings($container) {
            let $nextSibling = $container.querySelector("#start-synchro").nextElementSibling;
            let $parent = $container.querySelector("#start-synchro").parentElement;
            const nextSiblings = [];
            while ($nextSibling) {
                if ($nextSibling.id === "end-synchro") break;
                nextSiblings.push($nextSibling);
                $nextSibling = $nextSibling.nextElementSibling;
            }
            return { parent: $parent, nextSiblings };
        },
        getPrevSiblings($container) {
            let $prevSibling = $container.querySelector("#end-synchro").previousElementSibling;
            let $parent = $container.querySelector("#end-synchro").parentElement;
            const prevSiblings = [];
            while ($prevSibling) {
                prevSiblings.unshift($prevSibling);
                $prevSibling = $prevSibling.previousElementSibling;
            }
            return { parent: $parent, prevSiblings };
        },
        appendNewChildren($parent, siblings) {
            if ($parent.tagName !== "DIV") {
                const $divContainer = document.createElement("div");
                siblings.forEach(sibling => $divContainer.appendChild(sibling));
                return $divContainer.outerHTML;
            } else {
                $parent.innerHTML = "";
                siblings.forEach(sibling => $parent.appendChild(sibling));
                return $parent.outerHTML;
            }
        },
    },
    computed: {
        body() {
            const $container = document.createElement("div");
            $container.innerHTML = this.synchronizedSection.body;
            if ($container.querySelector("#start-synchro")) {
                const { parent, nextSiblings } = this.getNextSiblings($container);
                return this.appendNewChildren(parent, nextSiblings);
            } else if ($container.querySelector("#end-synchro")) {
                const { parent, prevSiblings } = this.getPrevSiblings($container);
                return this.appendNewChildren(parent, prevSiblings);
            }
            return $container.innerHTML;
        },
    },
});
</script>

<style lang="sass"></style>
